import { AgGridReact } from 'ag-grid-react';
import React from 'react';
import { createContext } from 'react';

import { BillingReportRow, UiMessage, BillingReportResult } from '../types';

export const hasGrid = (
  grid?: AgGridReact<BillingReportRow> | null
): grid is AgGridReact<BillingReportRow> => {
  // grid.api is undefined until ag-grid's onGridReady fires, and only null
  // after the grid is destroyed -- `!== null` alone let the undefined case
  // through, so callers crashed calling into an api that wasn't there yet.
  return !!grid?.api;
};

interface BillingReportContextType {
  apiToken: string;
  reportId: number;
  billingReportResult?: BillingReportResult;
  reportEndAt: Date | null;
  healthieUrl: string;
  messages: UiMessage[];
  setErrorMessage: (message: string) => void;
  setMessages: (messages: UiMessage[]) => void;
  gridRef: React.RefObject<AgGridReact<BillingReportRow> | null>;
}

export const BillingReportContext = createContext<BillingReportContextType>({
  healthieUrl: '',
  reportId: -1,
  reportEndAt: null,
  setErrorMessage: () => {
    /* noop */
  },
  setMessages: () => {
    /* noop */
  },
  messages: [],
  apiToken: '',
  gridRef: {} as React.RefObject<AgGridReact<BillingReportRow> | null>
});
interface BillingReportProviderProps extends Omit<BillingReportContextType, 'billingReportResult'> {
  children: React.ReactNode;
  billingReportResult?: BillingReportResult;
}

// Define a provider to wrap the BillingReportResultApp component
export const BillingReportProvider: React.FC<BillingReportProviderProps> = ({
  apiToken,
  children,
  reportEndAt,
  healthieUrl,
  messages,
  reportId,
  setErrorMessage,
  setMessages,
  gridRef,
  billingReportResult
}) => {
  return (
    <BillingReportContext.Provider
      value={{
        apiToken,
        reportEndAt,
        healthieUrl,
        messages,
        reportId,
        setErrorMessage,
        setMessages,
        gridRef,
        billingReportResult
      }}>
      {children}
    </BillingReportContext.Provider>
  );
};
